export const colorStates = {
    'outlined-quinary': [
        'text-quinary-500',
        'hover:bg-quinary-100',
        'active:bg-quinary-400',
        'disabled:text-tertiary-300',
        'disabled:bg-tertiary-100',
    ],
    'primary-light-bg': [
        'bg-primary-500 text-white',
        'disabled:bg-tertiary-400',
    ],
    'secondary-light-bg': [
        'bg-secondary-500 text-white',
        'disabled:bg-tertiary-300',
    ],
    'tertiary-light-bg': [
        'border border-primary-500 text-primary-500',
        'disabled:text-tertiary-300',
        'disabled:border-tertiary-300',
        'disabled:italic',
    ],
    'primary-dark-bg': [
        'bg-tertiary-500 text-white',
        'disabled:bg-tertiary-400',
    ],
    'secondary-dark-bg': [
        'bg-secondary-500 text-white',
        'disabled:bg-tertiary-300',
    ],
    'tertiary-dark-bg': [
        'border border-white text-white',
        'disabled:border-tertiary-200',
        'disabled:border-text-tertiary-200',
        'disabled:italic',
    ],
    'danger-primary-light-bg': [
        'bg-quinary-400 text-white',
        'disabled:bg-tertiary-400',
    ],
    'danger-secondary-light-bg': [
        'border border-quinary-400 text-quinary-400',
        'disabled:bg-tertiary-300',
        'disabled:border-none',
        'disabled:text-white',
    ],
    'danger-tertiary-light-bg': [
        'underline text-quinary-400',
        'disabled:text-tertiary-400',
        'disabled:italic',
    ],
    'danger-primary-dark-bg': [
        'bg-quinary-400 text-white',
        'disabled:bg-tertiary-400',
    ],
    'danger-secondary-dark-bg': [
        'border border-quinary-400 text-quinary-400 bg-quinary-100',
        'disabled:bg-tertiary-300',
        'disabled:border-none',
        'disabled:text-white',
    ],
    'danger-tertiary-dark-bg': [
        'underline text-quinary-400',
        'disabled:text-tertiary-200',
        'disabled:italic',
    ],
};
